var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBloodtype(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.995 1L14.655 6.66C15.7743 7.77861 16.5368 9.20406 16.8459 10.7561C17.155 12.308 16.9969 13.9168 16.3915 15.379C15.7862 16.8411 14.7608 18.0908 13.4451 18.9701C12.1294 19.8494 10.5825 20.3187 9 20.3187C7.41753 20.3187 5.8706 19.8494 4.5549 18.9701C3.23919 18.0908 2.21381 16.8411 1.60847 15.379C1.00312 13.9168 0.844998 12.308 1.15411 10.7561C1.46321 9.20406 2.22566 7.77861 3.345 6.66L8.995 1Z",
    fill: "#A2D45E",
    fillOpacity: 0.15,
    stroke: "#4CAF51",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBloodtype);
export default __webpack_public_path__ + "static/media/bloodtype.bc38df326f6b11885ae0e4a921caaa7e.svg";
export { ForwardRef as ReactComponent };